export const AUTH_BASE_URL = "https://ca.account.sony.com/api/authz/v3/oauth";
